import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import { PackageTypeEditDialog } from '../../Dialogs/Configuration/PackageTypeEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function PackageTypeTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getPackageTypes = async function () {
            let url = `api/v1/packageType/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getPackageTypes();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Alternative Name',
            accessor: 'alternativeName',
            filter: 'includesString'
        },
        {
            Header: 'Units Per Package',
            accessor: 'unitsPerPackage',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Weight Per Unit',
            accessor: 'unitWeight',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={{}} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function PackageType() {
    const { businessUnits } = useBusinessUnits(false);

    const getNewPackageType = () => {
        return { id: null, name: "", unitsPerPackage: 0, unitWeight: 0 };
    };

    return (
        <CommonConfigPage
            title={"Package Type"}
            Table={PackageTypeTable}
            Dialog={PackageTypeEditDialog}
            getNewConfigObject={getNewPackageType}
            businessUnits={businessUnits}
        />
    );
}

export default PackageType;